import { createSelector } from '@reduxjs/toolkit';
import { computersForMap } from './computers-for-map';

export const standalonePrinters = createSelector(computersForMap, (computers) =>
  computers.filter(function (c) {
    return c.unitType === 'printer' && !c.networkUuid;
  }),
);
